import React from 'react'
import './LinkFooter.css'

import { Link } from 'react-router-dom'
import { translate, Trans } from 'react-i18next'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'


const LinkFooter = (props) => {
  return(
    <ReactCSSTransitionGroup
      transitionName="imgTransition"
      transitionAppear={true}
      transitionAppearTimeout={500}
      transitionEnter={false}
      transitionLeave={false}>
      <React.Fragment>
        <div className="linkFooter">
          { props.items.map( (item, index) => 
            <Link key={index} to={item.url}> 
              {item.svg} {props.t(item.label)} 
            </Link> ) }
        </div>
        <div className="textFooter">
          <Trans i18nKey='linkFText'>
            А ще… <br/> Ми запропонуємо професійні послуги по догляду за Вашими розкішними рослинами.
          </Trans>
        </div>
      </React.Fragment>
    </ReactCSSTransitionGroup>
  )
}

export default translate('translations')(LinkFooter)


// WEBPACK FOOTER //
// ./src/components/LinkFooter.jsx